module.exports = __webpack_public_path__ + "static/media/loading-spinner-red.32c7506f.svg";